import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import makeAnimated from "react-select/animated";
import { getApiData } from "../../../helpers/AxiosInstance";
// @ts-ignore
import { tw } from "@careinfo/tailwind";

const animatedComponents = makeAnimated();

const MultipleSelectField = (props: any) => {
  const {
    name,
    setValue,
    label,
    url,
    value = [],
    clearErrors,
    errors,
    props: otherProps,
  } = props;

  const limit = 10;

  const handleChange = (options: any[]) => {
    setValue(name, options, {
      shouldDirty: true,
      shouldValidate: true,
    });
    clearErrors?.(name);
  };
  const loadOptions = async (inputValue: string) => {
    const response = await getApiData(url, {
      limit: 10,
      offset: 0,
      search: inputValue,
      ...otherProps,
    });

    const options =
      response?.data?.results?.map((item: any) => ({
        label: item.name,
        value: item.id,
      })) ?? [];

    return [
      ...(value ?? []).filter(
        (sel: any) => !options.some((opt) => opt.value === sel.value)
      ),
      ...options,
    ];
  };

  return (
    <div className={tw`mt-4`}>
      <label>{label}</label>

      <AsyncSelect
        isMulti
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        value={value}
        onChange={handleChange}
        components={animatedComponents}
        closeMenuOnSelect={false}
        styles={{
          control(base) {
            return { ...base, backgroundColor: "#EEF5F4", border: "none" };
          },
        }}
      />

      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors.message}</p>
      )}
    </div>
  );
};

export default MultipleSelectField;
